import type { FaireProductEntity } from "../../entity_types/product";

export const p_ccgnghp3u6: FaireProductEntity = {
  token: "p_ccgnghp3u6",
  type: "product",
  name: "Chirps and Cheers Tea Towel",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6d2170379f479103d679f4780eadd1f2b005a20aca0f75290ed9fd394e817214.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/acc220af4e01ab0c8738dd55f83cf5c830af2d21c08d5fce4945315deaec82cf.jpeg",
    "https://cdn.faire.com/fastly/79b68d431e8bd60e38e7532c2b76ab38bc80a8280f864caa7222a1bfd382e7f8.jpeg",
    "https://cdn.faire.com/fastly/90d3fdb3eff604e0e3e4a4a0cfbc8d29352ec76aa11ed9b349d9f1b0bba27811.jpeg",
  ],
  priceDollars: 11,
  description:
    "So is THAT what all the birders are looking for? Tiny wineglasses?! Clever birds... we love hearing your songs and now we love knowing why you're singing - you're sipping! These E. Frances towels bring beauty and sweetness, chirps and cheers to your kitchen.\n\n100% cotton\n21\" x 28\" ",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:09.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
